import React from 'react';
import {Routes,Route,HashRouter} from 'react-router-dom';
import Home from './pages/Home';
import Chatbots from './pages/Chatbots';
import News from './pages/News';
import Simulator from './pages/Simulator';
import './index.css';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chatbots" element={<Chatbots />} />
        <Route path="/news" element={<News />} />
        <Route path="/simulator" element={<Simulator />} />
      </Routes>
    </HashRouter>
  );
}

export default App;